import { render } from "./TheAbout.vue?vue&type=template&id=bec7a792"
import script from "./TheAbout.vue?vue&type=script&lang=js"
export * from "./TheAbout.vue?vue&type=script&lang=js"

import "./TheAbout.vue?vue&type=style&index=0&id=bec7a792&lang=scss"

import exportComponent from "C:\\Programming\\VUE projects\\ELTECH\\eltech-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__